module.exports = __webpack_public_path__ + "img/fabricas-e-industrias-bc4f2ff9.jpg";